import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { isBrowser } from 'utils/browser';

import { setGMapsError } from '../redux/main/actions/gMapsError';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/ban-types
type OwnProps = {};
type Props = OwnProps & {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setGMapsError: (...args: Array<any>) => any;
};

class SetGMapsError extends React.PureComponent<Props> {
  componentDidMount() {
    if (isBrowser()) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ pageData: { landingSearch?: Object; }; } |... Remove this comment to see the full error message
      window.Idealist = window.Idealist || {};

      // @ts-expect-error ts-migrate(2339) FIXME: Property 'setGMapsError' does not exist on type '{... Remove this comment to see the full error message
      window.Idealist.setGMapsError = (errorType) => {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/destructuring-assignment
        this.props.setGMapsError(errorType);
      };
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'gmapsErrors' does not exist on type '{ p... Remove this comment to see the full error message
    if (Array.isArray(window.Idealist.gmapsErrors)) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'gmapsErrors' does not exist on type '{ p... Remove this comment to see the full error message
      window.Idealist.gmapsErrors.forEach((errorType) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'setGMapsError' does not exist on type '{... Remove this comment to see the full error message
        window.Idealist.setGMapsError(errorType);
      });
    }
  }

  render() {
    return null;
  }
}

// @ts-expect-error ts-migrate(2558) FIXME: Expected 2 type arguments, but got 1.
export default withRouter<OwnProps>(
  connect(null, {
    setGMapsError,
  })(SetGMapsError)
);
